module.exports = "/build/web/svg/sponsor/mac3park-wit.91af5bd1777a853355b5d920319c9905.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/sponsor/mac3park-wit.svg
// module id = 216
// module chunks = 24